var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetflix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FDFDFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84591 24.013C8.38305 24.0946 7.91205 24.119 7.42482 24.1842L5.9387 19.8167V24.3716C5.47584 24.4205 5.05357 24.4857 4.61505 24.5508V16.2069H5.84943L7.53849 20.9412V16.2069H8.84591V24.013ZM11.4039 19.2626C11.9074 19.2626 12.6789 19.2381 13.1418 19.2381V20.5418C12.5652 20.5418 11.8912 20.5418 11.4039 20.5663V22.5056C12.1673 22.4567 12.9306 22.3915 13.7021 22.367V23.6218L10.1046 23.9071V16.2069H13.7021V17.5107H11.4039V19.2626ZM18.5339 17.5107H17.1858V23.5079C16.7473 23.5079 16.3088 23.5079 15.8866 23.5241V17.5107H14.5386V16.2069H18.5339L18.5339 17.5107ZM20.6452 19.1729H22.4237V20.4767H20.6452V23.4346H19.3702V16.2069H23.0002V17.5107H20.6452V19.1729ZM25.1116 22.2937C25.8506 22.31 26.5976 22.3671 27.3204 22.4078V23.6953C26.1592 23.6219 24.9979 23.5486 23.8123 23.5241V16.2069H25.1116V22.2937ZM28.4167 23.7849C28.8308 23.8094 29.2694 23.8338 29.6916 23.8827V16.2069H28.4167V23.7849ZM35.3843 16.2069L33.7357 20.1752L35.3843 24.5508C34.897 24.4857 34.4098 24.396 33.9225 24.3145L32.9887 21.9027L32.0386 24.119C31.5675 24.0375 31.1128 24.013 30.6419 23.9478L32.3147 20.1262L30.8042 16.2069H32.2009L33.0536 18.3988L33.9631 16.2069H35.3843Z",
    fill: "#D81F26"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetflix);
export default __webpack_public_path__ + "static/media/netflix.c8ec06aef654e35240f6fe1f3f302304.svg";
export { ForwardRef as ReactComponent };